// extracted by mini-css-extract-plugin
module.exports = {"auto":"Icon_auto__WB6i_","xSmall":"Icon_xSmall__2lT1h","small":"Icon_small__1G2FD","medium":"Icon_medium__1ySV-","large":"Icon_large__1-Lji","xLarge":"Icon_xLarge__1uQa8"};